import { styled } from '__legacy__/lib/stitches'

export const Root = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '48px'
})
